import { render, staticRenderFns } from "./DispensaPacienteUnidade.vue?vue&type=template&id=a9f54be8"
import script from "./DispensaPacienteUnidade.vue?vue&type=script&lang=js"
export * from "./DispensaPacienteUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports